module finadai.services {
    interface SearchResults {
        clients: models.Customer[];
        credits: models.Credit[];
    }

    export class CustomersService {
        static instanceName = 'customersService';

        constructor(private proxifier, private $http: ng.IHttpService) {
        }

        register(data) {
            return this.$http.post([this.proxifier(), 'finadai', 'customers', 'validate'].join('/'), data);
        }

        validate(token) {
            return this.$http.get([this.proxifier(), 'finadai', 'customers', 'confirm', token].join('/'));
        }

        search(customer_number): ng.IHttpPromise<models.http.responses.Record<SearchResults>> {
            return this.$http.post([this.proxifier(), 'finadai', 'customers', 'search'].join('/'), {search_number: customer_number});
        }

        get(customer_number, trash?): ng.IHttpPromise<models.http.responses.Record<models.Customer>> {
            var config: ng.IRequestShortcutConfig = {
                transformResponse: (_data, headers, status) => {
                    var data: models.http.responses.Record<models.Customer> = util.PropertiesTransformInterceptor(_data, headers, status);
                    if (status == 200) {
                        if (angular.isDefined(data.data.phones)) {
                            angular.forEach(data.data.phones, phone => {
                                switch (phone.type) {
                                    case 'Celular':
                                        phone.type_icon = 'smartphone';
                                        break;
                                    default:
                                        phone.type_icon = 'local_phone';
                                        break;
                                }
                            });
                        }
                    }
                    return data;
                },
                params: {
                    with: 'locations,emails,phones,negotiations,credits,negotiations.payment_type,negotiations.granter,activities,media,references.relationship'
                }
            }
            if (trash) {
                config.params.with_trash = 1;
            }
            return this.$http.get([this.proxifier(), 'finadai', 'customers', customer_number].join('/'), config);
        }

        getInfo() {
            return this.$http.post([this.proxifier(), 'finadai', 'customers', 'get_info'].join('/'), {});
        }

        delete(id, entity?, customerId?) {
            if (angular.isDefined(entity)) {
                return this.$http.delete([this.proxifier(), 'finadai', 'customers', customerId, entity, id].join('/'));
            }
            return this.$http.delete([this.proxifier(), 'finadai', 'customers', id].join('/'));
        }

        deleteFile(id, customer_id) {
            return this.$http.post([this.proxifier(), 'finadai', 'customers', 'de_attach_file'].join('/'), {
                media_id: id,
                customer_id: customer_id
            });
        }

        save(data, id, entity, customerId) {
            if (id) {
                if (entity != null) {
                    return this.$http.put([this.proxifier(), 'finadai', 'customers', customerId, entity, id].join('/'), data);
                }
                return this.$http.put([this.proxifier(), 'finadai', 'customers', id].join('/'), data);
            }
            else {
                if (entity != null) {
                    return this.$http.post([this.proxifier(), 'finadai', 'customers', customerId, entity].join('/'), data);
                }
                return this.$http.post([this.proxifier(), 'finadai', 'customers'].join('/'), data);
            }
        }

        getActivityTypes() {
            return this.$http.get([this.proxifier(), 'finadai', 'activity_types'].join('/'));
        }

        getRelationshipTypes() {
            return this.$http.get([this.proxifier(), 'finadai', 'relationships'].join('/'));
        }

        getCreditStatus() {
            return this.$http.get([this.proxifier(), 'finadai', 'credit_status'].join('/'));
        }

        recordActivity(data): ng.IHttpPromise<models.Activity> {
            return this.$http.post([this.proxifier(), 'finadai', 'activities'].join('/'), data);
        }

        sendInvite(data) {
            return this.$http.post([this.proxifier(), 'finadai', 'customers', 'invitation'].join('/'), data);
        }

        deactivateCustomer(data) {
            return this.$http.post([this.proxifier(), 'finadai', 'customers', 'inactive_customer'].join('/'), data);
        }

        activateCustomer(data) {
            return this.$http.post([this.proxifier(), 'finadai', 'customers', 'active_customer'].join('/'), data);
        }

        changeStatusCredit(data) {
            return this.$http.post([this.proxifier(), 'finadai', 'credits', 'inactive'].join('/'), data);
        }

        getPendingNegotiations(): ng.IHttpPromise<models.http.responses.Records<models.Customer>> {
            return this.$http.post([this.proxifier(), 'finadai', 'customers', 'pending_negotiations'].join('/'), {});
        }

        getCauses() {
            return this.$http.get([this.proxifier(), 'finadai', 'get_causes'].join('/'));
        }

        updateName(customer_id, data) {
            return this.$http.post([this.proxifier(), 'finadai', 'customers', customer_id, 'edit_name'].join('/'), data);
        }

        getActivities(params): ng.IHttpPromise<models.http.responses.Records<models.Activity>> {
            return this.$http.get([this.proxifier(), 'finadai', 'activities'].join('/'), {params: params});
        }

        downloadActivities(filters): ng.IHttpPromise<any> {
            return this.$http.post([this.proxifier(), 'finadai', 'activities', 'excel_cron'].join('/'), {}, {params: filters});
        }

        proxySearch(data) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.Credito>>(`${this.proxifier()}/finadai/proxy/search`, data);
        }

        proxyNewSearch(data) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.Find>>(`${this.proxifier()}/finadai/proxy/new_search`, data);
        }

        proxySearchCredit(data) {
            return this.$http.post(`${this.proxifier()}/finadai/proxy/credit`, data);
        }

        proxySaveManualNegotiation(data) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.Negociacion>>(`${this.proxifier()}/finadai/proxy/save_manual_negotiation`, data);
        }

        proxyRegister(data) {
            return this.$http.post(`${this.proxifier()}/finadai/proxy/create_user`, data);
        }

        proxyValidate(token) {
            return this.$http.get(`${this.proxifier()}/finadai/proxy/validate_user/${token}`);
        }

        proxyGetCustomer(data) {
            return this.$http.post(`${this.proxifier()}/finadai/proxy/customer`, data);
        }

        proxyGetNegotiation(data) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.Negociacion>>(`${this.proxifier()}/finadai/proxy/negotiation`, data);
        }
        proxySearchNegotiation(data) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.SearchNegociacion>>(`${this.proxifier()}/finadai/proxy/negotiation_search`, data);
        }
        proxyPaymentOptions(data) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.PaymentOption[]>>(`${this.proxifier()}/finadai/proxy/default_payments`, data);
        }

        proxySaveNegotiation(data) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.Negociacion>>(`${this.proxifier()}/finadai/proxy/save_negotiation`, data)
        }

        proxySaveCustomer(data) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.Customer>>(`${this.proxifier()}/finadai/proxy/customer_update`, data)
        }

        proxyAccessToken(token) {
            return this.$http.get(`${this.proxifier()}/finadai/proxy/access_token/${token}`);
        }

        proxyCancelNegotiation(data) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.Negociacion>>(`${this.proxifier()}/finadai/proxy/cancel_negotiation`, data)
        }

        proxyUpdateCustomerAdmin(data) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.Negociacion>>(`${this.proxifier()}/finadai/proxy/admin_update`, data)
        }

        proxyValidateCellphone(cellphone) {
            return this.$http.post<models.http.responses.ProxyRecord<models.proxy.Codigo>>(`${this.proxifier()}/finadai/proxy/validate_phone`, cellphone)
        }

        proxyCreateReferenceAdmin(data) {
            return this.$http.post(`${this.proxifier()}/finadai/proxy/admin_create_reference`, data)
        }

        proxyChangeSICCustomerAdmin(data) {
            return this.$http.post(`${this.proxifier()}/finadai/proxy/admin_change_sic`, data)
        }

        proxyGetOriginator() {
            return this.$http.get<models.http.responses.ProxyRecord<models.proxy.Originadores>>(`${this.proxifier()}/finadai/proxy/originators`);
        }
    }
}
